import { create } from 'zustand';

interface StoreStates {
  value: string;
  openAskAi: boolean;
}

interface Store extends StoreStates {
  setValue: (value: string) => void;
  setOpenAskAi: (openAskAi: boolean) => void;

  reset: () => void;
}

const initalState: StoreStates = {
  value: '',
  openAskAi: false
};

export const useAskAIStorage = create<Store>(set => ({
  ...initalState,

  setValue: (newValue: string) => set({ value: newValue }),
  setOpenAskAi: (newOpen: boolean) => set({ openAskAi: newOpen }),
  reset: () => set({ ...initalState })
}));
